import { Drawer } from "@circleco/compass/components/Drawer";
import type { DrawerSnapTo } from "@circleco/compass/components/Drawer";
import { Icon } from "@circleco/compass/components/Icon";
import type { IconName } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

import { DRAWER_ITEM_BUTTON_CLASS } from "./drawerItemStyles";

interface NestedDrawerMenuItemProps {
  /** Accessible label for the nested drawer content. */
  ariaLabel: string;
  /** Content rendered inside the nested child drawer. */
  children: ReactNode;
  icon: IconName;
  label: string;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  snapTo?: DrawerSnapTo;
}

/**
 * A drawer row that opens a nested child drawer when tapped
 * (e.g. "Switch community", "Appearance", "Admin settings").
 *
 * The trigger reuses the standard drawer-row styling; the nested
 * drawer's open state is controlled by the parent so it can be
 * force-closed as part of a `closeAll` chain.
 */
export const NestedDrawerMenuItem = ({
  icon,
  label,
  snapTo,
  open,
  onOpenChange,
  ariaLabel,
  children,
}: NestedDrawerMenuItemProps) => (
  <Drawer.Root open={open} onOpenChange={onOpenChange} snapTo={snapTo}>
    <Drawer.Trigger>
      <button type="button" className={DRAWER_ITEM_BUTTON_CLASS}>
        <Icon name={icon} size="md" />
        <Typography variant="body-md">{label}</Typography>
      </button>
    </Drawer.Trigger>
    <Drawer.Content aria-label={ariaLabel}>{children}</Drawer.Content>
  </Drawer.Root>
);
